'use strict';

function applyAdOptions(target) {
  // ADS

  /**
   * @prop {object} [ad.metadata]
   * Item containing mixed extra information about ads like: request url.
   * This object may store any serializable key:value info.
   */
  target['ad.metadata'] = {};

  /**
   * @prop {string} [ad.campaign]
   * String containing the name of the campaign
   */
  target['ad.campaign'] = undefined;

  /**
   * @prop {string} [ad.creativeId]
   * String containing the id of the creative
   */
  target['ad.creativeId'] = undefined;

  /**
   * @prop {string} [ad.provider]
   * String containing the provider of the ad
   */
  target['ad.provider'] = undefined;

  /**
   * @prop {string} [ad.resource]
   * String containing the ad resource
   */
  target['ad.resource'] = undefined;

  /**
   * @prop {string} [ad.title]
   * String containing the title of the campaign
   */
  target['ad.title'] = undefined;

  /**
   * @prop {duration} [ad.duration]
   * Duration of the ad in seconds
   */
  target['ad.duration'] = undefined;

  /**
   * @prop {object} [ad.expectedPattern]
   * Json with the position of the breaks expected.
   * Arrays are the number of breaks, and the numbers in them, the number of ads for each break
   *
   * Example:
   * {pre: [1],
   * mid: [1,2],
   * post: [1]}
   * Would be a view with 1 preroll break with 1 ad, 2 midroll breaks, one with 1 ad and
   * the other with 2, and one postroll break with 1 ad.
   */
  target['ad.expectedPattern'] = undefined;

  /**
   * @prop {string} [ad.givenAds]
   * Number of ads given by the adserver for this break
   */
  target['ad.givenAds'] = undefined;

  /**
   * @prop {number[]} [ad.breaksTime]
   * Array of numbers for the time position of adbreaks
   */
  target['ad.breaksTime'] = undefined;

  /**
   * @prop {string} [ad.expectedBreaks]
   * Number of breaks expected for the view
   */
  target['ad.expectedBreaks'] = undefined;

  /**
   * @prop {number} [ad.givenBreaks]
   * Number of breaks given by the adserver for the view
   */
  target['ad.givenBreaks'] = undefined;

  /**
   * @prop {boolean} [ad.ignore]
   * False by default.
   * If true, npaw blocks ad events and calculates jointime ignoring ad time.
   */
  target['ad.ignore'] = false;

  /**
   * @prop {boolean} [ad.blockerDetected]
   * Null (notified as false) by default.
   * Sets if an adblocker has been detected
   */
  target['ad.blockerDetected'] = undefined;

  /**
   * @prop {number} [ad.postRollTimeout]
   * Timeout to wait for a postroll ad
   * Default: 1000ms
   */
  target['ad.postRollTimeout'] = 1000;

  // ADS CUSTOM DIMENSIONS

  /** @prop {string} [ad.customDimension.1] Ad custom parameter 1. */
  target['ad.customDimension.1'] = undefined;

  /** @prop {string} [ad.customDimension.2] Ad custom parameter 2. */
  target['ad.customDimension.2'] = undefined;

  /** @prop {string} [ad.customDimension.3] Ad custom parameter 3. */
  target['ad.customDimension.3'] = undefined;

  /** @prop {string} [ad.customDimension.4] Ad custom parameter 4. */
  target['ad.customDimension.4'] = undefined;

  /** @prop {string} [ad.customDimension.5] Ad custom parameter 5. */
  target['ad.customDimension.5'] = undefined;

  /** @prop {string} [ad.customDimension.6] Ad custom parameter 6. */
  target['ad.customDimension.6'] = undefined;

  /** @prop {string} [ad.customDimension.7] Ad custom parameter 7. */
  target['ad.customDimension.7'] = undefined;

  /** @prop {string} [ad.customDimension.8] Ad custom parameter 8. */
  target['ad.customDimension.8'] = undefined;

  /** @prop {string} [ad.customDimension.9] Ad custom parameter 9. */
  target['ad.customDimension.9'] = undefined;

  /** @prop {string} [ad.customDimension.10] Ad custom parameter 10. */
  target['ad.customDimension.10'] = undefined;
}

module.exports = applyAdOptions;

